import { GLOBAL_TERM_REFERENCE } from './help/components/xplenty-console.component';

function hasSomeParentTheClass(element: HTMLElement, classname: string) {
  if (element.className && element.className.split(' ').indexOf(classname) >= 0) return true;
  return element.parentNode && hasSomeParentTheClass(element.parentNode as HTMLElement, classname);
}

document.addEventListener('copy', function (e) {
  let text;
  const isSelectionFromOldTerminal = hasSomeParentTheClass(
    window.getSelection().anchorNode.parentElement,
    'terminal-component',
  );

  if (isSelectionFromOldTerminal || GLOBAL_TERM_REFERENCE) {
    text = window.getSelection().toString() || GLOBAL_TERM_REFERENCE.getSelection();
    text = text.replace(/[\n\r]+[ ]+/g, '').replace(/[\n\r]+/g, '');
    e.clipboardData.setData('text/plain', text);
    e.preventDefault();
  }
});
